// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1fbMP","title":"ClientInsurance_title__3uquV","itemText":"ClientInsurance_itemText__2vrjx"};